import React, { FC } from 'react'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { useSelector } from 'react-redux'
import { eventsIdSelectors } from '@ucheba/store/events/id'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import PlayIcon from '@ucheba/ui/icons/icon__circled-play.svg'
import { EModButtonColor } from '@ucheba/ui/components/Button/types'
import { EEventRegisteredStatus } from '../../EventsList/types'
import { useEventsListItemCore } from '../../EventsList/bll'

interface IButtonRegEvent {
  color: keyof typeof EModButtonColor | null
}

const ButtonRegEvent: FC<IButtonRegEvent> = (props) => {
  const { color } = props
  const event = useSelector(eventsIdSelectors.entity)

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { streamUrl } = event

  const { buttonData, onClickRegistration, registersPending } =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    useEventsListItemCore(event)

  return (
    <Button
      color={color || 'blue'}
      onClick={onClickRegistration}
      progress={registersPending}
      target='_blank'
      StartIcon={
        buttonData.eventRegisteredStatus === EEventRegisteredStatus.watchBroadcast &&
        streamUrl ? (
          <PlayIcon width='20px' height='20px' />
        ) : null
      }
      href={
        buttonData.eventRegisteredStatus === EEventRegisteredStatus.watchBroadcast
          ? streamUrl
          : undefined
      }
    >
      {buttonData.eventRegisteredStatus === EEventRegisteredStatus.watchBroadcast
        ? 'Смотреть'
        : buttonData.buttonText}
    </Button>
  )
}

export default ButtonRegEvent
